<template>
  <!--  -->
  <div class="sd-overlays-container" v-if="zoom_ > minZoom_ && zoom_ < maxZoom_"> 
    <sd-overlay2 v-for="(item,index) in list_" :key="index" :map="map" :max="max_" :coordinate="item.coordinate" :props="overlayProps_" >
      <div >
        <div v-if="type_.includes('label')" v-html="getContentHtml(item) " :class="className_" @click.stop="handleClickOverlay(item)" />
        <img v-if="type_.includes('image')" :src="getImage(item)" :style="style_" class="image-icon" @click.stop="handleClickOverlay(item)" > 
        <SingleHistogram v-if="type_.includes('histogram')"  :data="getHistogram(item)" @chart-click="handleClickOverlay(item)"></SingleHistogram>
      </div>
      
    </sd-overlay2>
  </div>
</template>

<script>
import SingleHistogram from '@/components/SingleHistogram.vue'
export default {
  name: 'SdOverlays',
  components:{SingleHistogram},
  props: {
    /**
     * Overlay集合
     *  type: <Stirng>   数据展示效果类型(label,histogram,image) 必填
     *  list: <Array>    数据，必填
     *  getCoordinate: <Function> 获取xy方法，必填
     *  callback: <Function>   点击回调函数，选填
     *  props: <Object> overlay 参数，选填
     *  className:<Stirng> overlay最外层样式，选填
     *  minZoom: <Number>  显示最小层级，选填
     *  maxZoom: <Number>  显示最大层级，选填
     *  image:<Stirng> 图片路径，选填
     *  getImage:<Function> 获取图片方法，选填
     *  getContent: <Function> 获取Label方法，选填
     */
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    /**
     * 当前地图层级
     */
    zoom:{
      type:String,
      default:null
    },
    map: {
      type: Object,
      default() {
        return null
      }
    },
  },
  data() {
    return {
      list_ :[],
      type_:'label',
      overlayProps_:{},
      style_:[],
      maxZoom_:99,
      minZoom_:0,
      zoom_:0,
      max_:100
    };
  },
  watch:{
    map() {
      this.init()
    },
    data(){
      this.init()
    },
    zoom(){
      this.zoom_ = this.tryGetZoom()
      // console.log("tryGetZoom",this.zoom_,this.maxZoom_,this.minZoom_,this.zoom_ > this.minZoom_ && this.zoom_ < this.maxZoom_);
    }
  },
  mounted() {
    this.init()
  },
  
  methods: {
    handleClickOverlay(item){
      this.data.callback && this.data.callback(item)
    },
    init(){
      this.zoom_ = this.tryGetZoom()
      this.list_ = []
      
      if (!this.data || !this.map) return
      const data = this.data
      this.list_ = this.getStanderList(data.list)
      data.getValue && (this.max_ = Math.max.apply(Math,this.list_.map(item => { return data.getValue(item) })))
      this.type_ = data.type
      this.overlayProps_ = data.props ||{positioning:'bottom-center'}
      this.style_= data.style_
      this.maxZoom_ = data.maxZoom || 99
      this.minZoom_ = data.minZoom || 0

      console.log("this.list_",this.list_)
    },
    getCoordinate(item){
      if (item.coordinate) {
        return item.coordinate
      }
      else if(this.data.getCoordinate){
        return this.data.getCoordinate(item)
      }
      return null
    },
    getContentHtml(item){
      var value = ""
       if(this.data.getContent){
        value = this.data.getContent(item)
      }
      return `<div class="custom-label-style">${value}</div>`
    },
    getImage(item){
      var image = 'hzszz.png'
      if(item.image){
        image= item.image
      }else if(item.getImage){
        image= item.getImage(item)
      }else if(this.data.image){
        image= this.data.image
      }else if(this.data.getImage){
        image= this.data.getImage(item)
      }
      return image
    },
    tryGetZoom(){
      var zoom = 0
      try {
        zoom = Number(this.zoom)
      } catch (error) {
        console.warn("zoom 转换失败，",this.zoom);
      }
      
      return zoom
    },
    getStanderList(list){
      const arr = []
      list.forEach(item=>{
        arr.push({
          coordinate:item.coordinate?item.coordinate:this.getCoordinate(item),
          ...item
        })
      })
      return arr
    },
    getHistogram(item){

      if (this.data.getHistogram) {
        return this.data.getHistogram(item)
      }
      return {xData:null,yData:null}
    }
  },
};
</script>

<style scoped>
.image-icon{
  width: 30px;
  height: 30px;
}
</style>